export const getStyles = (theme, language) => {
  const styles = {
    pageContainer: {
      minHeight: "100vh",
      background: theme === "dark"
        ? "linear-gradient(135deg, #0f1419 0%, #1a1f35 50%, #0d1628 100%)"
        : "linear-gradient(135deg, #f8fafb 0%, #eef2f5 50%, #e5f0f7 100%)",
      padding: "24px",
      fontFamily: language === "ar"
        ? "'Cairo', 'Segoe UI', sans-serif"
        : "'Segoe UI', 'Helvetica Neue', sans-serif",
      direction: language === "ar" ? "rtl" : "ltr",
    },
  card: {
    background: theme === "dark" ? "rgba(15,23,42,0.8)" : "rgba(255,255,255,0.95)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderRadius: "20px",
    padding: "28px",
    marginBottom: "24px",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.15)"
      : "1px solid rgba(0,0,0,0.05)",
    boxShadow: theme === "dark"
      ? "0 8px 32px rgba(0,0,0,0.3)"
      : "0 8px 32px rgba(0,0,0,0.08)",
  },
  cardTitle: {
    fontSize: "18px", fontWeight: "700",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    marginBottom: "20px", display: "flex", alignItems: "center", gap: "12px",
  },
  title: {
    fontSize: "28px", fontWeight: "700",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    margin: 0,
  },
  button: {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    gap: "8px", padding: "12px 24px", borderRadius: "12px", border: "none",
    cursor: "pointer", fontSize: "14px", fontWeight: "600",
    transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)", fontFamily: "inherit",
  },
  primaryButton: { background: "#2e7cba", color: "#ffffff" },
  secondaryButton: {
    background: theme === "dark" ? "rgba(148,163,184,0.12)" : "rgba(15,23,42,0.06)",
    color: theme === "dark" ? "#cbd5e1" : "#374151",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.2)"
      : "1px solid rgba(15,23,42,0.1)",
  },
  inputGroup: { marginBottom: "20px" },
  label: {
    display: "block", fontSize: "13px", fontWeight: "600",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b", marginBottom: "8px",
  },
  input: {
    width: "100%", padding: "12px 14px", borderRadius: "12px",
    background: theme === "dark" ? "rgba(51,65,85,1.8)" : "#ffffff",
    border: "1px solid rgba(148,163,184,0.3)",
    fontSize: "14px", fontFamily: "inherit",
    transition: "all 0.3s ease", boxSizing: "border-box",
  },
  textarea: { minHeight: "100px", resize: "vertical" },
  levelCard: {
    background: theme === "dark" ? "rgba(30,41,59,0.6)" : "rgba(248,250,252,0.7)",
    borderRadius: "16px", padding: "20px", marginBottom: "16px",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.15)"
      : "1px solid rgba(15,23,42,0.05)",
    transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)", cursor: "pointer",
    boxShadow: theme === "dark" ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 8px rgba(0,0,0,0.04)",
  },
  moduleCard: {
    background: theme === "dark" ? "rgba(15,23,42,0.5)" : "rgba(255,255,255,0.8)",
    padding: "18px", borderRadius: "12px", marginBottom: "12px",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.15)"
      : "1px solid rgba(15,23,42,0.05)",
  },
  toggle: {
    width: "48px", height: "26px", borderRadius: "13px",
    border: "none", cursor: "pointer", position: "relative",
    transition: "all 0.3s ease",
    background: theme === "dark" ? "rgba(100,120,150,0.3)" : "rgba(200,210,230,0.4)",
  },
  toggleActive: {
    background: theme === "dark"
      ? "linear-gradient(135deg,#10b981,#059669)"
      : "linear-gradient(135deg,#34d399,#10b981)",
  },
  toggleButton: {
    position: "absolute", width: "22px", height: "22px",
    borderRadius: "50%", background: "#ffffff", top: "2px",
    transition: "all 0.3s ease", boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  smallToggle: { width: "36px", height: "20px", borderRadius: "10px" },
  smallToggleButton: { width: "16px", height: "16px" },
  modal: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.65)", backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)", display: "flex",
    alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px",
  },
  modalContent: {
    background: theme === "dark" ? "rgba(15,23,42,0.95)" : "rgba(255,255,255,0.98)",
    borderRadius: "24px", padding: "32px", maxWidth: "600px", width: "100%",
    maxHeight: "90vh", overflowY: "auto",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.15)"
      : "1px solid rgba(0,0,0,0.05)",
    boxShadow: theme === "dark"
      ? "0 20px 60px rgba(0,0,0,0.4)"
      : "0 20px 60px rgba(0,0,0,0.15)",
  },
  modalHeader: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", marginBottom: "24px",
  },
  modalTitle: {
    fontSize: "22px", fontWeight: "700",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b", margin: 0,
  },
  modalFooter: { display: "flex", gap: "12px", justifyContent: "flex-end" },
  alert: {
    padding: "16px 20px", borderRadius: "12px", marginBottom: "20px",
    display: "flex", alignItems: "center", gap: "12px",
    fontSize: "14px", fontWeight: "500",
  },
  alertSuccess: {
    background: theme === "dark" ? "rgba(16,185,129,0.15)" : "rgba(16,185,129,0.1)",
    border: `1px solid ${theme === "dark" ? "rgba(16,185,129,0.3)" : "rgba(16,185,129,0.2)"}`,
    color: theme === "dark" ? "#34d399" : "#059669",
  },
  alertError: {
    background: theme === "dark" ? "rgba(239,68,68,0.15)" : "rgba(239,68,68,0.1)",
    border: `1px solid ${theme === "dark" ? "rgba(239,68,68,0.3)" : "rgba(239,68,68,0.2)"}`,
    color: theme === "dark" ? "#f87171" : "#dc2626",
  },
  gridTwo: { display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))", gap: "16px" },
  sectionBox: {
    padding: "20px", borderRadius: "12px", marginBottom: "20px",
    border: theme === "dark"
      ? "1px solid rgba(148,163,184,0.15)"
      : "1px solid rgba(15,23,42,0.05)",
    background: theme === "dark" ? "rgba(15,23,42,0.4)" : "rgba(248,250,252,0.7)",
  },
  sectionTitle: {
    fontWeight: "700", fontSize: "14px", marginBottom: "12px",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
  },
  checkboxLabel: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "10px 12px", cursor: "pointer", borderRadius: "8px",
    transition: "all 0.2s", background: "transparent",
    userSelect: "none", WebkitTapHighlightColor: "transparent",
  },
  companyGroup: {
    marginBottom: "20px", paddingBottom: "16px",
    borderBottom: theme === "dark"
      ? "1px solid rgba(148,163,184,0.06)"
      : "1px solid rgba(15,23,42,0.04)",
  },
  companyTitle: {
    fontSize: "13px", fontWeight: "600",
    color: theme === "dark" ? "#cbd5e1" : "#475569",
    marginBottom: "8px", paddingBottom: "6px",
    borderBottom: theme === "dark"
      ? "1px solid rgba(148,163,184,0.1)"
      : "1px solid rgba(15,23,42,0.05)",
  },
  featureItem: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "6px 0", fontSize: "13px",
    color: theme === "dark" ? "#cbd5e1" : "#475569",
  },
  iconButton: {
    background: "transparent", border: "none", cursor: "pointer",
    padding: "8px", borderRadius: "8px", transition: "all 0.2s",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  emptyState: {
    textAlign: "center", padding: "40px 20px",
    color: theme === "dark" ? "#94a3b8" : "#64748b",
  },
  loadingState: {
    textAlign: "center", padding: "20px",
    color: theme === "dark" ? "#cbd5e1" : "#64748b",
  },
  tipText: {
    fontSize: "12px", color: theme === "dark" ? "#94a3b8" : "#64748b",
    fontStyle: "italic", marginTop: "10px",
  },
  actionButtons: { display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "20px" },
  smallButton: { padding: "8px 16px", fontSize: "13px", borderRadius: "10px" },
  featuresList: {
    paddingLeft: language === "ar" ? "0" : "20px",
    paddingRight: language === "ar" ? "20px" : "0",
  },
  searchInput: {
    width: "100%", padding: "10px 12px", borderRadius: "10px",
    border: "1px solid rgba(148,163,184,0.2)", marginBottom: "12px",
    fontSize: "14px", background: theme === "dark" ? "rgba(8,10,15,0.6)" : "#fff",
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))",
    gap: "12px",
    marginTop: "6px",
  },
  featureCard: {
    padding: "12px", borderRadius: "10px", cursor: "pointer",
    border: "1px solid rgba(15,23,42,0.05)", background: theme === "dark" ? "rgba(255,255,255,0.02)" : "#fff",
    display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center",
    transition: "all 0.18s ease",
  },
  featureCardActive: {
    boxShadow: "0 6px 18px rgba(16,24,40,0.08)",
    transform: "translateY(-4px)",
    border: "1px solid rgba(34,197,94,0.3)",
    background: theme === "dark" ? "linear-gradient(135deg, rgba(34,197,94,0.12), rgba(16,185,129,0.06))" : "linear-gradient(135deg, rgba(34,197,94,0.06), rgba(16,185,129,0.03))",
  },
  featureCardLabel: { fontSize: "14px", fontWeight: 600, color: theme === "dark" ? "#e6eef7" : "#0f172a" },
    stickyHeader: {
      position: "sticky",
      top: 0,
      zIndex: 1000,
      background: theme === "dark"
        ? "linear-gradient(180deg, rgba(15, 23, 42, 0.95) 0%, rgba(15, 23, 42, 0.8) 100%)"
        : "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.9) 100%)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      padding: "16px 0",
      marginBottom: "24px",
      borderBottom: theme === "dark"
        ? "1px solid rgba(148, 163, 184, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.05)",
      boxShadow: theme === "dark"
        ? "0 4px 16px rgba(0, 0, 0, 0.2)"
        : "0 4px 16px rgba(0, 0, 0, 0.05)",
    },
    saveButton: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      padding: "12px 28px",
      borderRadius: "12px",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      color: "#ffffff",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
      fontFamily: "inherit",
    },
    saveButtonHover: {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(16, 185, 129, 0.4)",
    },
    modernCard: {
      background: theme === "dark"
        ? "linear-gradient(135deg, rgba(30, 41, 59, 0.0) 0%, rgba(15, 23, 42, 0.0) 100%)"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      borderRadius: "20px",
      padding: "28px",
      marginBottom: "24px",
      border: theme === "dark"
        ? "1px solid rgba(148, 163, 184, 0.15)"
        : "1px solid rgba(0, 0, 0, 0.05)",
      boxShadow: theme === "dark"
        ? "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)"
        : "0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    animatedButton: {
      position: "relative",
      overflow: "hidden",
    },
    buttonHoverEffect: {
      position: "absolute",
      top: 0,
      left: "-100%",
      width: "100%",
      height: "100%",
      background: "rgba(255, 255, 255, 0.2)",
      transition: "left 0.3s ease",
    },
    statsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "16px",
      marginBottom: "24px",
    },
    statCard: {
      background: theme === "dark"
        ? "linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.5) 100%)"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 100%)",
      borderRadius: "16px",
      padding: "24px",
      border: theme === "dark"
        ? "1px solid rgba(148, 163, 184, 0.1)"
        : "1px solid rgba(0, 0, 0, 0.05)",
      boxShadow: theme === "dark"
        ? "0 4px 12px rgba(0, 0, 0, 0.15)"
        : "0 4px 12px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s ease",
    },
    statLabel: {
      fontSize: "13px",
      fontWeight: "600",
      color: theme === "dark" ? "#94a3b8" : "#64748b",
      marginBottom: "8px",
    },
    statValue: {
      fontSize: "32px",
      fontWeight: "700",
      color: theme === "dark" ? "#f1f5f9" : "#1e293b",
      margin: 0,
    },
  };

  return styles;
};